export default function Welcome() {
  return <div>Välkommen</div>;
}
